import React from 'react'
import {Box,Card,CardHeader, CardBody,Text,CardFooter,Heading,Spinner, NameValueList,NameValuePair, Button, Tip } from 'grommet';
import {Alert, Clock, Currency, Sync} from 'grommet-icons';


function QuoteCardShip(props) {
  const load = props.load
  const quote = props.quote
  let view;
  if (load){
    view = (<Card margin={'small'} style={{position:'fixed', minWidth:260}} round  pad="xsmall" background='background-front' elevation='large'  animation={{ type: 'fadeIn', duration: 500 }}><CardHeader justify='center' margin='small'><Text align='center' size='xsmall'>Loading Quick Quote...</Text></CardHeader><CardBody pad='small'><Spinner /></CardBody></Card>)
  } else if (props.error){
    view = (
        <Card margin={'small'} style={{minWidth:260}} pad="xsmall" background='background-front' round  elevation='large' animation={{ type: 'fadeIn', duration: 500 }}>
         <CardHeader justify='start'>
         <Alert color='status-critical'/>
             <Heading level={4} size="small">Quote Unsuccessful</Heading>
         </CardHeader>
         <CardBody justify='start' direction='column' margin='small'>
                 <Text size='small'>There is an error in requesting your quote. Please check the shipment details and requote.</Text>
                 <Text margin={{top:'small'}}size='small'>If the problem persists, please contact <a href="mailto:labship@samplelogistics.com?subject=LabShip Quoting Error">labship@samplelogistics.com</a>.</Text>
         </CardBody>
         <CardFooter>
          <Button onClick={() => {props.requestQuote(true, props.shipmentPieceDetails)}} primary icon={<Sync />} size='small' label={<Text size='xsmall'>Requote</Text>} />
        </CardFooter>
     </Card>
      )
    }  else if (quote.status === 'success') {
        view = (
       <Card margin='small' style={{position:'fixed', maxWidth:260}} round  pad="xsmall" background='background-front' elevation='large' animation={{ type: 'fadeIn', duration: 500 }}>
       <CardHeader pad='small' direction='row' justify='start'>
           <Text weight={'bold'} style={{marginLeft: 5, marginTop:2}}>Shipment Quote</Text>
       </CardHeader>
       {(props.size === 'small') ?
        <CardBody justify='center' pad='small' overflow='scroll'>
            <Text style={{marginTop:13}} weight='bold' size='small'>{quote.quote.total_quote_price} {quote.quote.total_quote_price_currency}</Text>
            {/* <Text style={{fontSize:'12px', fontWeight:'bold'}}>Please note this is an approximate quote and the final total may be subject to additional duties and taxes.</Text> */}
        </CardBody> 
        : 
       <Box style={{minWidth:260}}>
       <CardBody pad='small' overflow='scroll' direction='row' >
        <NameValuePair name={<Box direction='row'><Clock color='brand' /></Box>} icon={<Clock />}>
           <Tip plain content={<Box direction='row' elevation='large' margin='medium' pad="small" gap="small" width={{ max: 'large' }} round background="white"><Alert color='status-warning' /><Text margin={{top:'xxsmall'}} weight='bold' size='small'>Please note transit times are an estimate, actual delivery times may vary.</Text></Box>}><Text size='small' m weight={'bold'}  margin={{left:'small', top:'xxsmall'}}>Transit Time: {quote.quote.transit_time} Day(s)</Text></Tip>
        </NameValuePair>
       </CardBody>
       <CardBody pad='small' direction='row'>
       <NameValuePair name={<Box direction='row'><Currency color='brand' /></Box>} icon={<Currency />}>
            <Tip plain content={<Box direction='row' elevation='large' margin='medium' pad="small" gap="small" width={{ max: 'large' }} round background="white"><Alert color='status-warning' /><Text margin={{top:'xxsmall'}} weight='bold' size='small'>Please note this is an approximate quote based on the weight and dimensions provided. The final total may be subject to additional duties and taxes.</Text></Box>}><Text size='small'  weight={'bold'}  margin={{left:'small', top:'xxsmall'}}>Quote: ${quote.quote.total_quote_price} {quote.quote.total_quote_price_currency}</Text></Tip>
        </NameValuePair>
       </CardBody>
       <CardFooter pad='small'>
         <Button hoverIndicator onClick={() => {props.requestQuote(true, props.shipmentPieceDetails)}} primary icon={<Sync />} size='small' label={<Text weight={'bold'} size='small'>Requote</Text>} />
       </CardFooter>
       </Box>
       }
       
    </Card>
     )
} else if (quote.status === 'fail') {
    view = (
   <Card margin={'small'} style={{minWidth:260}} pad="xsmall" background='background-front' round  elevation='large' animation={{ type: 'fadeIn', duration: 500 }}>
    <CardHeader justify='start'>
    <Alert color='status-critical'/>
        <Heading level={4} size="small">Quote Unsuccessful</Heading>
    </CardHeader>
    <CardBody justify='start' direction='column'>
        <NameValueList layout='grid' margin='small' nameProps={{ width: 'xxsmall' }}  pairProps={{ direction: 'column' }}>
            <NameValuePair name={<Text size='small' weight={'bold'}>Error Code</Text>}>
                <Text size='small'>{quote.response.Status.Code}</Text>
            </NameValuePair>
            <NameValuePair name={<Text size='small' weight={'bold'}>Error Message</Text>}>
                <Text size='small'>{quote.response.Status.Message}</Text>
            </NameValuePair>
        </NameValueList>
    </CardBody>
    <CardFooter>
     <Button onClick={() => {props.requestQuote(true, props.shipmentPieceDetails)}} primary icon={<Sync />} size='small' label={<Text size='xsmall'>Requote</Text>} />
   </CardFooter>
</Card>
 )
  } else {
      view = null;
  }
  return (
    <Box>
        {view}
    </Box>
  )
}

export default QuoteCardShip
